/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetUserSessionsRequest} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'
import {GetUserSessionsResponse} from '@cash-web/protos/squareup/cash/kgoose/api/v3/session_messages.pb'


export const genericGetUserSessions = (request:GetUserSessionsRequest, options?: CashRequestOptions) => post<GetUserSessionsRequest, GetUserSessionsResponse>("/2.0/cash/generic-get-user-sessions", request, {...options, rejectOnError: true })